import { NavLink } from 'react-router-dom';
import logoUrl from '../../assets/logo.svg';
import { NavRfpIcon, NavVendorIcon } from '../icons/Icons';

interface NavEntry {
  to: string;
  label: string;
  icon: React.ReactNode;
}

/**
 * Both entries the design shows in the rail. The Figma component set
 * ("Component 1694") also defines Import Jobs, Delivery, Billing and Payment,
 * Job Tracking, Tasks and Approvals, Admin, Audit Trail and Today's Plan - they
 * are hidden in the frame, so they are intentionally not rendered here.
 */
const NAV_ENTRIES: NavEntry[] = [
  { to: '/rfp', label: 'RFP', icon: <NavRfpIcon size={18} /> },
  { to: '/vendor-master', label: 'Vendor Master', icon: <NavVendorIcon size={14} /> },
];

export function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="sidebar__logo">
        <img src={logoUrl} alt="Company logo" width={32} height={40} />
      </div>

      <nav className="sidebar__nav" aria-label="Main navigation">
        {NAV_ENTRIES.map((entry) => (
          <NavLink
            key={entry.to}
            to={entry.to}
            className={({ isActive }) => `nav-item ${isActive ? 'nav-item--active' : ''}`.trim()}
          >
            {entry.icon}
            <span className="nav-item__label">{entry.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
